import { createSlice } from '@reduxjs/toolkit';

/**
 * Estado global para ventas con factura de exportación.
 */
interface ExportInvoiceSaleState {
    showAddProductModal: boolean;
    showEditProductModal: boolean;
    exportItemType: number | null;
}

const initialState: ExportInvoiceSaleState = {
    showAddProductModal: false,
    showEditProductModal: false,
    exportItemType: null,
};

const exportInvoiceSaleSlice = createSlice({
    name: 'exportInvoiceSale',
    initialState,
    reducers: {
        /**
         * Abre el modal para agregar un nuevo producto.
         */
        openAddProductModal(state) {
            state.showAddProductModal = true;
        },

        /**
         * Cierra el modal de agregar producto.
         */
        closeAddProductModal(state) {
            state.showAddProductModal = false;
        },

        /**
         * Abre el modal de edición de producto.
         */
        openEditProductModal(state) {
            state.showEditProductModal = true;
        },

        /**
         * Cierra el modal de edición de producto.
         */
        closeEditProductModal(state) {
            state.showEditProductModal = false;
        },

        setExportItemType(state, action) {
            state.exportItemType = action.payload;
        },

    },
});

export const {
    openAddProductModal,
    closeAddProductModal,
    openEditProductModal,
    closeEditProductModal,
    setExportItemType,
} = exportInvoiceSaleSlice.actions;

export default exportInvoiceSaleSlice.reducer;
